import { httpGet } from '../../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../../constants/constants';
import type { JitsiTokenResponse } from './types';

/**
 * Retrieves JWT token for JaaS authentication
 *
 * @method getJwtToken
 * @memberof Jitsi
 * @param  {number} patientId - Patient user ID
 * @returns {Promise<JitsiJwtToken>} - JWT token
 */

export const getJwtToken = (patientId?: number): Promise<JitsiTokenResponse> => {
  let url;

  if (patientId) {
    url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/conference/token/${patientId}`);
  } else {
    url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/conference/token`);
  }

  return httpGet(`${url.href}`, {})
    .then((results) => {
      if (results?.data.success) {
        return {
          token: results.data.jaas_token,
          room: results.data.room_name,
        };
      }

      throw new Error('Error retrieving JaaS Token');
    })
    .catch((error) => {
      throw new Error(`Error retrieving JaaS Token ${error}`);
    });
};
